import { render, staticRenderFns } from "./PixPayment.vue?vue&type=template&id=0126446f&scoped=true"
import script from "./PixPayment.vue?vue&type=script&lang=js"
export * from "./PixPayment.vue?vue&type=script&lang=js"
import style0 from "./PixPayment.scss?vue&type=style&index=0&id=0126446f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0126446f",
  null
  
)

export default component.exports